import {Labour} from '../models/labour/labour.model';
import {JobLabour} from '../models/labour/jobLabour.model';

export namespace LabourActions {
  export class GetLabours {
    static readonly type = '[Labour api] GetLabours';

    constructor(public force: boolean = false) {
    }
  }

  export class GetLabour {
    static readonly type = '[Labour api] GetLabour';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateLabour {
    static readonly type = '[Labour api] CreateLabour';

    constructor(public labour: Labour) {
    }
  }

  export class UpdateLabour {
    static readonly type = '[Labour api] Update Labour';

    constructor(public labour: Labour) {
    }
  }

  export class DeleteLabour {
    static readonly type = '[Labour api] Delete Labour';

    constructor(public labour: Labour) {
    }
  }

  export class GetJobLabour {
    static readonly type = '[Labour api] GetJobLabour';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateJobLabour {
    static readonly type = '[Labour api] UpdateJobLabour';

    constructor(public jobLabour: JobLabour) {
    }
  }
}
